/*
 * Since the WebSDK is not yet available on npm, we asynchronously
 * load the UMD version from the appropriate env whenever the SDK is initialized
 * for the first time.
 */

const formatUmdUrl = ( env ) => {
	return new URL(
		window.PayoneerData.webSdkUmdUrlTemplate?.replace( '<env>', env )
	);
};

const sdkLoader = ( config ) => {
	if ( window.Payoneer?.CheckoutWeb ) {
		return window.Payoneer.CheckoutWeb( config );
	}

	return new Promise( ( resolve, reject ) => {
		const script = document.createElement( 'script' );
		script.src = formatUmdUrl( config.env );
		script.onload = resolve;
		script.onerror = reject;
		document.head.appendChild( script );
	} ).then( () => {
		return window.Payoneer.CheckoutWeb( config );
	} );
};

export default sdkLoader;
